import { register } from "register-service-worker";

console.log("import.meta.env.MODE: ", import.meta.env.MODE);
if (import.meta.env.MODE === "production" || import.meta.env.MODE === "development") {
  const swPath = `${import.meta.env.BASE_URL}service-worker.js`;
  console.log(swPath, 'swPath');
  register(swPath, {
    ready() {
      console.log("Service worker has been ready");
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
      // document.dispatchEvent(new CustomEvent("appUpdated", { detail: null }));
      // document.dispatchEvent(new CustomEvent("refreshApp"));
    },
    cached(registration) {
      console.log("Service worker Content has been cached for offline use", registration);
      if (localStorage.getItem('content_downloading') === 'true') {
        localStorage.removeItem('content_downloading');

        // Lanza evento para mostrar el modal
        document.dispatchEvent(new CustomEvent("appUpdated", { detail: { ...registration, waiting: true } }));
      }
    },
    updatefound() {
      console.log("New content is downloading.");
      localStorage.setItem('content_downloading', 'true')
    },
    updated(registration) {
      console.log("Service worker New content is available; please refresh", registration);

      if (localStorage.getItem('content_downloading') === 'true') {
        localStorage.removeItem('content_downloading');

        // Lanza evento para mostrar el modal
        document.dispatchEvent(new CustomEvent("appUpdated", { detail: registration }));
      }
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
    
  });
}
